import { connect } from 'react-redux';
import { SubmissionError } from 'redux-form';
import { browserHistory } from 'react-router';
import { loadSurety, getNextStep, submitForm, stopSubmitForm } from '../actions/users';
import validate from '../components/Validations/submitSuretyForm';
import { getErrorsApiToReduxForm } from '../utils/utils.js';
import SuretyForm from '../components/SuretyForm';

const mapStateToProps = (state) => {

    return {
        isValidating: false,
        isLoading: state.users.isLoading
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        //For any field errors upon submission (i.e. not instant check)
        setSurety(values, dispatch, ownProps) {
            dispatch(submitForm());
            let errors = validate(values);
            if( Object.keys(errors).length !== 0){
                const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))
                return sleep(10).then(() => {
                    dispatch(stopSubmitForm());
                    throw new SubmissionError({ ...errors, _error: 'Revisá los campos indicados.' })
                })
            }else{
                return dispatch(loadSurety(values)).then((result) => {
                    if (result.payload.status !== 200) {
                        dispatch(stopSubmitForm());
                        throw new SubmissionError ({...getErrorsApiToReduxForm(result.payload.response.data), _error: 'Revisá los campos indicados.'});
                    } else {
                        dispatch(getNextStep()).then((result) => {
                            if (typeof(result.payload.data.endpoint) !== 'undefined') {
                                sessionStorage.setItem('endpoint',result.payload.data.endpoint);
                                dispatch(stopSubmitForm());
                                browserHistory.push(result.payload.data.endpoint);
                            }
                        });
                    }
                });
            }
    }
}
}

export default connect(mapStateToProps, mapDispatchToProps)(SuretyForm);



/** WEBPACK FOOTER **
 ** ./src/containers/SuretyFormContainer.js
 **/